/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ReactElement } from "react";

import { IMediaCategoryModel, MediaCategoryType } from "@nf/common";
import { AppConfig, IS_CHILD_COOKIE } from "@nf/constants";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";

import type {
  Channel,
  SearchScreenProps,
} from "screens/SearchScreen/SearchScreen";

const Layout = dynamic(() => import("layouts/Layout"));

const SearchScreen = dynamic(() => import("screens/SearchScreen"));

import styles from "screens/SearchScreen/SearchScreen.module.scss";

const CHANNELS: Channel[] = [
  {
    url: `/${AppConfig.ChannelHome}`,
    icon: `/assets/nf-plus.svg`,
    ageRestricted: true,
  },
  {
    url: `/${AppConfig.ChannelDansk}`,
    icon: `/assets/dansk-filmskat.svg`,
    ageRestricted: true,
  },
  {
    url: `/${AppConfig.ChannelKids}`,
    icon: `/assets/kids.svg`,
    ageRestricted: false,
  },
];

export const getServerSideProps: GetServerSideProps<SearchScreenProps> = async (
  ctx
) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);

  const cookies = ctx.req.cookies;
  const isChild = cookies?.[IS_CHILD_COOKIE] === "true";

  let genreList: IMediaCategoryModel[] = [];
  const mediaCategories = await DataProvider.getMediaCategories(true);

  if (mediaCategories) {
    genreList = mediaCategories.Entities.filter(
      (item) => item.CategoryTypeCode === MediaCategoryType.Main
    );
  }

  return {
    props: {
      ...commonProps,
      enableRecommendations: !isChild,
      genreList,
      channels: CHANNELS.filter((channel) => {
        if (isChild && channel.ageRestricted) {
          return false;
        }
        return true;
      }),
    },
  };
};

const SearchScreenWrapper = (props: SearchScreenProps) => {
  return <SearchScreen {...props} />;
};

SearchScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout config={props?.config} className={styles.layout}>
      <NextSeo nofollow />
      {page}
    </Layout>
  );
};

export default SearchScreenWrapper;
